module.exports = __webpack_public_path__ + "media/images/break-d48018e4b8ab66d3967444c62a8bf47d.svg";